var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRotateCcw = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.0926 3 6.04936 5.44378 3.62627 9H8.25C8.66421 9 9 9.33579 9 9.75C9 10.1642 8.66421 10.5 8.25 10.5H2.25C1.83579 10.5 1.5 10.1642 1.5 9.75V3.75C1.5 3.33579 1.83579 3 2.25 3C2.66421 3 3 3.33579 3 3.75V7.26752C5.22859 4.10671 7.6499 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.74967 22.5 2.40058 18.6472 1.62347 13.6145C1.56026 13.2051 1.84087 12.822 2.25023 12.7588C2.65959 12.6956 3.04269 12.9762 3.1059 13.3855C3.77181 17.6981 7.501 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRotateCcw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rotate-ccw.b361e3fd09423763b067f0aa10b5df72.svg";